import React, { useState, useRef, useEffect } from "react";
// import { Button } from "../Button";
import { Link } from "react-router-dom";
import { Modal } from "../Modal/Modal";
import LangSelect from "./LangSelect";
import ComboSelect from '../ComboSelect/ComboSelect';

import MenuBar from '../MenuBar/MenuBar';

// import Dropdown from "./Dropdown";
import "./Header.css";
import lupa from "../../assets/img/lupa/TNCDigital_Web_Cercador_2.svg";
import menuLogo from "../../assets/img/lupa/TNCDigital_Web_Cercador_1.svg";
import closeLogo from "../../assets/img/lupa/TNCDigital_Web_Cercador_3.svg";

import logo2 from "../../assets/img/logo-02.svg";
import logo3 from "../../assets/img/logo-03.svg";
import logoTnc from "../../assets/img/TNCDigital2.869cc284.png"
// import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
function Navbar(props) {
  const [click, setClick] = useState(false);
  const [searchclick, setSearchClick] = useState(false);
  const [inputText, setInputText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const { lang } = props;

  const ref = useRef();
  //trick to close menus
  const modalRef = useRef();
  const buyMenuRef = useRef();
  // const langMenuRef=useRef();
  //en trick to close menus
  let history = useHistory();
  //
  const [inputSearchText, setInputSearchText] = useState("");
  //etiquetas segun idioma
  let search,
    login,
    linkSub,
    buy,
    subs,
    oneTicket,
    linktickets = "https://entrades.tnc.cat/?id_temporada=2477",
    logout = "";

  if (lang === "cat") {
    search = "Buscar";
    buy = "Comprar";
    subs = "Subscripció temporada";
    oneTicket = "Entrada 1 espectacle";
    linkSub = "https://entrades.tnc.cat/ca/mes-productes?Ex_id=32";
    login = "Iniciar sessió";
    logout = "Tancar sessió";
  }
  if (lang === "esp") {
    search = "Buscar";

    buy = "Comprar";
    subs = "Subscripción temporada";
    oneTicket = "Entrada 1 espectáculo";
    linkSub = " https://entrades.tnc.cat/es/mas-productos?Ex_id=32";
    login = "Inicia sesión";
    logout = "Cerrar sesión";
  }
  if (lang === "eng") {
    search = "Search";

    buy = "Buy";
    subs = "Season sign up";
    oneTicket = "Performance ticket";
    linkSub = "https://entrades.tnc.cat/en/more-products?Ex_id=32";
    login = "Log in";
    logout = "Log out";
  }

  const handleClick = () => {
    setClick(!click);
  };
  const closeMobileMenu = () => setClick(false);

  const handleChange = (ev) => {
    // console.log(ev.target.value);
    setInputText(ev.target.value);
  };
  const handleSearchClick = () => {
    //  console.log('click');
    if (searchclick) {
      setInputText("");
      props.handleFilter(""); //borrar el filtrado al salir buscador
    }
    setSearchClick(!searchclick);
  };
  const handleClickLanguage = (ev) => {
    props.handleLang(ev.target.innerHTML.toLowerCase());
  };
  const handleFilter = (ev) => {
    ev.preventDefault();
    props.handleFilter(ev.currentTarget.firstChild.value);
    setClick(false); //o más búsquedas. a preguntar.
    setInputSearchText(ev.currentTarget.firstChild.value);
  };

  const openModal = () => {
    setShowModal((prev) => !prev);
  };

  const handler = (event) => {
    // changing the state to the name of the key
  // which is pressed
   console.log('evento::'+event.key);
};

  /**
   * Hook that alerts clicks outside of the passed ref
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      console.log('Alerter');
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          // alert("You clicked outside of me!");
          // setSearchClick(!searchclick);
          //handleSearchClick();
          setSearchClick(searchclick);
          // console.log('icono de cerrar::'+document.getElementById('close'));
          // let usu = document.getElementById("close");
          // console.log('Id::'+usu.alt);
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  /**
   * Hook that alerts clicks outside of the passed ref
   */
  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {

          if (((event.target.id === "oneTicketId") || (event.target.id === "subsId")) || (event.target.id === "buyId"))
          {
            //setShowItems(true); 
          }
          else
          {
            setShowItems(false);
          }
          if (event.target.alt === undefined) {
            setSearchClick(false);
            setInputText("");
            props.handleFilter(""); //borrar el filtrado al salir buscador
          }
          if (event.target.alt === "TNC_logo") {
            window.scroll(0, 0);
            history.push("/");
          }
          if (event.target.alt === "TNC_Digital_Logo") {
            window.scroll(0, 0);
            history.push("/");
          }
          if(event.target.alt === "" && document.getElementById('searchId').value)
          {
           
            console.log("busqueda::"+document.getElementById('searchId').value);
             window.scroll(0, 0);
            history.push("/"); 
          }
         // console.log("click en ::"+event.target.alt);
        
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  function useOutsideBuyMenu(ref2) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside2(event) {
        console.log("test");
        if (ref2.current && !ref2.current.contains(event.target)) {
          setShowItems(false);
         
        }
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside2);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside2);
        };
      }
    }, [ref2]);
  }

 

  //useeffect para quitar el panel de busqueda.
  useOutsideAlerter(modalRef);
  //use effect para quitar el panel del menu de compras
  useOutsideBuyMenu(buyMenuRef);
  
  function onKeyPressed(e) {
   console.log(e.key);
   if(e.keyCode === 13)
   {
    setShowModal(true);
   }
 
   
  };

   

  return (
    <>
      <div ref={ref}>
        <Modal
          showModal={showModal}
          setShowModal={setShowModal}
          lang={lang}
          isLoggedFunc={props.isLoggedFunc}
          // movie={assetIdTest}
        ></Modal>
      </div>
      <nav className="navbar">
        <div className="menu-icon" onClick={handleClick}>
          {click ? (
            <img tabindex="0" src={closeLogo} alt="logo menu" className="menu-icon-logo" />
          ) : (
            <img tabindex="0" src={menuLogo} tabindex="0" alt="logo menu" className="menu-icon-logo" />
          )}
        </div>
        <div className="navbar-logos">
         <div className="header__icon">
          <a href="https://tncdigital.cat/educatiuprofessionals/" onClick={closeMobileMenu}>
            {/* className="navbar-logo"  */}
            <img
              className="header__icon"
              src={logoTnc}
              alt="TNC_Digital_Logo"
            />
          </a>
        {/*<div className="servei">
           Servei educatiu
          </div>*/}
          </div>

        

     
        
         
          <Link to="/" onClick={closeMobileMenu}>
            {/* className="navbar-logo"  */}
            <img
              className="header__icon2"
              src="https://www.tnc.cat/images/logo-01.svg"
              alt="TNC logo"
            />
          </Link>
          <span className="col-wide visible-lg-block">
            <img
              className="col-wide-logo"
              src={logo2}
              width="104"
              height="22"
              alt="TEATRE NACIONAL DE CATALUNYA"
            />
            <img
              className="col-wide-logo logo2"
              src={logo3}
              width="145"
              height="22"
              alt="Generalitat de Catalunya Departament de Cultura"
            />
          </span>
        
         
        </div>
        
       
        <div className="navbar-texts">
       {/* Component Lang  */}   {/* <LangSelect lang={lang} handleLang={props.handleLang} />*/}
            <ComboSelect handleLang={props.handleLang}></ComboSelect>
          <div className="search-icon" onClick={handleSearchClick} ref={modalRef}>
            {searchclick ? (
              <img tabindex="0"
                src={closeLogo}
                alt="logo cerrar"
                className="search-icon-logo"
              />
            ) : (
              <img
                tabindex="0"
                id="close"
                src={lupa}
                className="search-icon-logo"
                alt="search logo"
              />
            )}
          </div>
         
          <div className="menu__texts">
          <MenuBar buy={buy} linkSub={linkSub} subs={subs} linktickets={linktickets} oneTicket={oneTicket}></MenuBar>
           {/* <ul tabindex="0">
            <li className="menu__texts-item">
              <div id='buyId'
                className="menu__texts-links"
                onClick={() => setShowItems((prev) => !prev)}
              >
                {buy}
              </div>
              {showItems ? (
                <div className="menu__texts-links-dropdown"  >
                  <a id="subsId"  href={linkSub} className="menu__texts-links-sec">
                    {subs}
                  </a>
                  <a id="oneTicketId"  href={linktickets} className="menu__texts-links-sec">
                    {oneTicket}
                  </a>
                </div>
              ) : (
                <></>
              )}
            </li>
              </ul>*/}
            {props.isLogged ? (
              <ul tabindex="0">
              <li
                className="menu__texts-item"
                onClick={() => props.isLoggedFunc(false)}
              >
                {" "}
                {logout}
              </li>
              </ul>
            ) : (
              <div tabindex="0" onKeyDown={onKeyPressed}>
              <ul >
              <li className="menu__texts-item"  onClick={() => openModal()}>
                {" "}
                {login}
              </li>
              </ul>
              </div>
            )}
          </div>
        </div>
        <div
          className={searchclick ? "navbar__search" : "navbar__search__hidden"}
        >
          <form className="navbar__search__box" onSubmit={handleFilter}>
            <input
              onChange={handleChange}
              className="navbar__search_input"
              type="text"
              value={inputText}
              autoFocus
              id="searchId"
              aria-label="Texto a buscar"
            ></input>
            <input
              type="submit"
              className="navbar__search_button"
              value={search}
              aria-label="Boton de buscar"
            ></input>
          </form>
        </div>
        <div className={click ? "dropdown" : "dropdown menuhidden"}>
          <div className="dropdown__texts">
           {/* <li className="nav-item">
              <div className="menu__texts-links">{buy}</div>
              <div className="menu__texts-links">
                <a href={linkSub} className="menu__texts-links-sec">
                  {subs}
                </a>
                <a href={linktickets} className="menu__texts-links-sec">
                  {oneTicket}
                </a>
              </div>
            </li>*/}
            {props.isLogged ? (
              <li
                className="nav-item"
                onClick={() => props.isLoggedFunc(false)}
              >
                {" "}
                {logout}
              </li>
            ) : (
              <li className="nav-item"  onClick={() => openModal()}>
                {" "}
                {login}
              </li>
            )}
          </div>
          <div tabindex="0" className="nav-menu-mobile-languaje-link"  >
            <div  tabindex="0"
              onClick={handleClickLanguage}
              className={
                lang === "cat"
                  ? "active `nav-menu-mobile-languaje-link-detail`"
                  : "`nav-menu-mobile-languaje-link-detail`"
              }
            >
              CAT
            </div>{" "}
            |{" "}
            <div tabindex="0"
              onClick={handleClickLanguage}
              className={
                lang === "esp"
                  ? "active `nav-menu-mobile-languaje-link-detail`"
                  : "`nav-menu-mobile-languaje-link-detail`"
              }
            >
              ESP
            </div>{" "}
            |{" "}
            <div
              onClick={handleClickLanguage}
              className={
                lang === "eng"
                  ? "active `nav-menu-mobile-languaje-link-detail`"
                  : "`nav-menu-mobile-languaje-link-detail`"
              }
            >
              ENG
            </div>
          </div>
        </div>
      </nav>
     
    </>
  );
}

export default Navbar;
